import React from "react";
import { FormComponent } from "../../../../react-core/Html/FormComponent";
import { TextBoxEditor } from "../../../../react-core/Html/TextBoxEditor";
import { ContentFilter } from "../Resource/Content";

interface IInsuredFundSwitchToProps {
    filter: any;
    handleFilterChange: (changes) => void;
    onSearchSwitchTo: VoidFunction;
    displayName: string;
}

interface IInsuredFundSwitchToState {}

export class InsuredFundSwitchTo extends FormComponent<IInsuredFundSwitchToProps, IInsuredFundSwitchToState> {
    constructor(props: IInsuredFundSwitchToProps) {
        super(props);
        this.state = {};
    }

    public render(): JSX.Element {
        return <>{this.renderFilters()}</>;
    }

    private renderFilters(): JSX.Element {
        const { SwitchToInstrumentCode } = this.props.filter;
        const { handleFilterChange, displayName } = this.props;
        return (
            <table className="data-table">
                <thead>
                    <tr>
                        <th>{"Instrument"}</th>
                        <th>{"Weighting(%)"}</th>
                    </tr>
                </thead>
                <tr>
                    <td>
                        <div className="row narrow-gutter">
                            <div className="col-12 col-sm-4">
                                <TextBoxEditor
                                    value={SwitchToInstrumentCode}
                                    placeholder={ContentFilter.fundCode}
                                    onChange={(v) => handleFilterChange({ SwitchToInstrumentCode: v })}
                                />
                            </div>
                            <div className="col-auto col-bottom">
                                <div className="form-group">
                                    <div className="controls">
                                        <button
                                            className="btn secondary"
                                            onClick={() => {
                                                if (this.isValid()) {
                                                    this.props.onSearchSwitchTo();
                                                }
                                            }}
                                        >
                                            {ContentFilter.validate}
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="col-auto">
                                <span>{displayName}</span>
                            </div>
                        </div>
                    </td>
                    <td>
                        <TextBoxEditor
                            placeholder="Weight"
                            required="Please enter weight"
                            value={"100"}
                            disabled={true}
                        />
                    </td>
                </tr>
            </table>
        );
    }
}
